import axios from "axios";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import api from "../api";

const FormContainer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0px 0px 5px #ccc;
  border-radius: 5px;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 100px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const InputId = styled.input`
  width: 30px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 40px;
`;

const Label = styled.label``;

const Button = styled.button`
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #2c73d2;
  color: white;
  height: 42px;
`;

const Title = styled.h2``;

const FormUsuarios = ({ getUsers, onEdit, setOnEdit }) => {
  const ref = useRef();

  useEffect(() => {
    if (onEdit) {
      const user = ref.current;

      user.id.value = onEdit.id;
      user.nome.value = onEdit.nome;
      user.login.value= onEdit.login;
      user.senha.value= onEdit.senha;
      user.valor.value= onEdit.valor;
      user.telefone.value= onEdit.telefone;
     
    }
  }, [onEdit]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = ref.current;

    if ( !user.nome.value ||
         !user.login.value ||
         !user.senha.value ||
         !user.valor.value ||
         !user.telefone.value
    ) {
      return toast.warn("Preencha todos os campos!");
    }

    /*if (onEdit) {
      await axios
        .put("http://localhost:8800/" + onEdit.id, {
          nome: user.nome.value,
          email: user.email.value,
          fone: user.fone.value,
          data_nascimento: user.data_nascimento.value,
        })
        .then(({ data }) => toast.success(data))
        .catch(({ data }) => toast.error(data));
    } else {*/

      await api.post("liga/addUsuario", 
        {
            id: Number(user.id ? user.id.value : 0),
            nome: user.nome.value,
            login: user.login.value,
            senha: user.senha.value,
            valor: user.valor.value,
            telefone: user.telefone.value,
            ativo: true
        }
      ).then(() => toast.success("Usuário salvo com sucesso!"))
       .catch((error) => toast.error(error.response?.data || "Erro ao salvar usuário!"));
     /* await axios
        .post("http://localhost:8800", {
          nome: user.nome.value,
          email: user.email.value,
          fone: user.fone.value,
          data_nascimento: user.data_nascimento.value,
        })
        .then(({ data }) => toast.success(data))
        .catch(({ data }) => toast.error(data));*/
   // }

     user.id.value = ""
     user.nome.value = ""
     user.login.value= ""
     user.senha.value= ""
     user.valor.value= ""
     user.telefone.value= ""
    

    setOnEdit(null);
    getUsers();
  };

  return (
    <FormContainer ref={ref} onSubmit={handleSubmit}>
     
      <InputArea>
        <Label>Id</Label>
        <InputId name="id" disabled />
      </InputArea>
      <InputArea>
        <Label>Nome</Label>
        <Input name="nome" />
      </InputArea>
      <InputArea>
        <Label>Login</Label>
        <Input name="login" />
      </InputArea>
      <InputArea>
        <Label>Senha</Label>
        <Input name="senha" />
      </InputArea>
      <InputArea>
        <Label>Telefone</Label>
        <Input name="telefone" />
      </InputArea>
      <InputArea>
        <Label>Saldo</Label>
        <InputId name="valor" />
      </InputArea>

      <Button type="submit">SALVAR</Button>
    </FormContainer>
  );
};

export default FormUsuarios;
